import api from '@/api'
import config from '@/config'
import dayjs from 'dayjs'
import Multiselect from 'vue-multiselect'
import CustomerItem from './CustomerItem'
import { mapGetters } from 'vuex'
import FilterCustomer from '@/components/elements/FilterCustomer'
import XLSX from 'xlsx'

export default {
  data: function() {
    var headers = []
    // console.log(this.$store.state.selectedBot)

    if (this.$store.state.selectedBot.theme == 'hafele') {
      headers.push({ text: this.$t('ID'), value: 'emp_id' })
    }

    headers = headers.concat([
      { text: '', sortable: false },
      { text: this.$t('name'), value: 'first_name' },
      { text: this.$t('Channel'), value: 'app' },
      { text: this.$t('gender'), value: 'gender' },
      { text: this.$t('Register Date'), value: 'registertimestamp' },
      { text: this.$t('Last Active Date'), value: 'timestamp' },
      { text: this.$t('Email'), value: 'email' },
      { text: this.$t('phone no.'), value: 'phoneno' },
      { text: this.$t('Status'), value: 'status' },
      { text: this.$t('Locale'), value: 'locale' },
      { text: this.$t('Lineid'), value: 'lineid' },
      { text: this.$t('Province'), value: 'province' },
      { text: this.$t('School'), value: 'school' },
      { text: '', sortable: false }
    ])

    return {
      headers: headers,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '' },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      intents: [],
      delayImport: false,
      search: '',
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        payStatus: {
          label: this.$t('All'),
          value: ''
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        lineid: '',
        school: '',
        province: '',
        uu_register_status: '',
        specialcondition: '',
        statustype: 'includes'
      },
      loading: true,
      errorFilterTag: [],
      pagetmp: 1,
      errorFilterStatus: [],
      customerfromfb: null,
      total_user: '',
      exportlimit: 5000,
      showExport: false,
      exportpagecount: 0,
      exportType: null
    }
  },
  components: {
    CustomerItem,
    Multiselect,
    FilterCustomer
  },
  mounted: async function() {
    var vm = this
    vm.getIntent(function() {
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function(users) {
          vm.offset += vm.limit
          vm.users = vm.users.concat(users)
          vm.loading = false
        },
        function() {
          vm.loading = false
        }
      )
    })
    vm.$store.dispatch('loadStatus')
  },
  computed: {
    pagelength() {
      if (this.total_user) {
        return Math.ceil(this.total_user / 100)
      } else {
        return 1
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filteredHeader() {
      if (this.isBU) return this.headers
      else if (this.$store.state.niveapage.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('gender'), value: 'gender' },
          { text: this.$t('Message Sent'), value: 'usermessages' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('Email'), value: 'email' },
          { text: this.$t('phone no.'), value: 'phoneno' },
          { text: this.$t('Status'), value: 'status' },
          // { text: this.$t('Message Sent'), value: 'messagesent' },
          { text: this.$t('Locale'), value: 'locale' },
          { text: '', sortable: false }
        ]
      } else {
        return this.headers.filter(v => {
          return !['lineid', 'province', 'school'].includes(v.value)
        })
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      computedImportDelay: 'getDelayCustomerImport'
    }),
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },
    filterIntent: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function(index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function(s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  methods: {
    onCountdownEnd() {
      this.$store.commit('REMOVE_DELAY_IMPORT', {
        pageid: this.selectedBot.pageid
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.pageloading = true
        this.getMoreCustomers()
      }
    },
    estimateReach: function(data) {
      var vm = this

      vm.loadingEstimate = true
      api.estimateReach({ data }, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.data) {
          vm.total_user = response.data.total
        }
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function(newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function(newTags) {
      this.status = newTags
    },
    clearSearch: function() {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function() {
      var vm = this
      vm.$validator.validate().then(result => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        vm.getLoadUsers(vm.limit, vm.offset).then(
          function(users) {
            vm.users = vm.users.concat(users)
            vm.loading = false
          },
          function(error) {
            vm.loading = false
          }
        )
      })
    },
    collectexportcustomersanalytic() {
      var vm = this
      let data = {
        pageid: vm.pageid,
        grouptype: vm.grouptype,
        filter: vm.filter,
        limit: vm.limit,
        offset: vm.offset
      }

      api.putcollectexportcustomersanalytic(data, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
      })
    },
    getLoadUsers: function(limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          filter: vm.filter,
          limit: limit,
          offset: offset,
          payment_flag: vm.filter.payStatus.value
        }

        api.getAllUsers(data, function(error, response) {
          if (error) {
            reject(error)
          }

          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          vm.total_user = response.count
          resolve(users)
        })
      })
    },
    getMoreCustomers: function() {
      var vm = this
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function(users) {
          vm.offset += vm.limit
          vm.users = users
          vm.loading = false
        },
        function(error) {
          vm.loading = false
        }
      )
    },
    onFailLoad: function(index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    },
    onActiveStartDate: function(value) {
      var vm = this
      if (dayjs(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function(value) {
      var vm = this
      if (dayjs(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function(value) {
      var vm = this
      if (dayjs(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function(value) {
      var vm = this
      if (dayjs(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function(index, val) {
            var intent = val
            intent.isShow = false
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },

    async exportDataSummary(offset) {
      let vm = this
      var limit = 5000
      vm.loading = true

      var users = await vm.getLoadUsers(limit, offset)
      if (users && users.length > 0) {
      }
      var json = []
      if (typeof users !== 'undefined') {
        users.map(item => {
          var userid =
            vm.$store.getters.getPackage == 'premium'
              ? item.id
                ? item.id
                : '-'
              : this.$t('premium')
          var userid_split = null
          try {
            userid_split = item.app == 'line' ? userid.split('__')[0] : userid
          } catch (error) {
            userid_split = userid
          }
          var userData = {
            pageuid: userid_split,
            'Social Name':
              (item.first_name ? item.first_name : '') +
              ' ' +
              (item.last_name ? item.last_name : ''),
            'E-mail': item.email,
            Phone: item.phoneno
          }
          if (item.session) {
            Object.assign(userData, JSON.parse(item.session))
          }
          json.push(userData)
        })
        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'zwiz-data-summary.csv')
        vm.loading = false
      }
      vm.collectexportcustomersanalytic()
    },

    exportCustomer: function(offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 5000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function(users) {
          if (users && users.length > 0) {
            var json = []
            $.each(users, function(index, val) {
              let locale = config.locale.find(function(locale) {
                if (val.locale == locale.value) {
                  return true
                }
              })
              var userid =
                vm.$store.getters.getPackage == 'premium'
                  ? val.id
                    ? val.id
                    : '-'
                  : this.$t('premium')
              var userid_split = null
              try {
                userid_split = val.app == 'line' ? userid.split('__')[0] : userid
              } catch (error) {
                userid_split = userid
              }
              var userData = {
                pageuid: userid_split,
                'Social Name':
                  (val.first_name ? val.first_name : '') +
                  ' ' +
                  (val.last_name ? val.last_name : ''),
                Channel: val.app,
                Gender: val.gender,
                'Register Date': val.registertimestamp
                  ? dayjs(val.registertimestamp).format('DD/MM/YYYY-HH:mm')
                  : '-',
                'Last Active Date': val.timestamp
                  ? dayjs(val.timestamp).format('DD/MM/YYYY-HH:mm')
                  : '-',
                Email:
                  vm.$store.getters.getPackage == 'premium'
                    ? val.email
                      ? val.email
                      : ''
                    : this.$t('premium'),
                Address: val.address,
                'Phone No':
                  vm.$store.getters.getPackage == 'premium' ? val.phoneno : this.$t('premium'),
                Status: vm.$store.getters.getPackage == 'premium' ? val.status : this.$t('premium'),
                Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : this.$t('premium'),
                // 'Message Sent':
                //   vm.$store.getters.getPackage == 'premium' ? val.messagesent : this.$t('premium'),
                Locale: locale ? locale : ''
                // Intent:
                //     vm.$store.getters.getPackage == 'premium'
                //         ? val.intentlist
                //             ? val.intentlist.join(',')
                //             : ''
                //         : this.$t('premium'),
                // MessageSent: val.questionmessages ? val.questionmessages.replace(/;;/gim, ',') : '',
                // NumberMessageSent: val.usermessages
              }

              json.push(userData)
            })

            // vm.exportCsv(csvContent, 'zwiz-customer-' + offset)
            const dataWS = XLSX.utils.json_to_sheet(json)
            const csv = XLSX.utils.sheet_to_csv(dataWS)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-customer.csv')
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function() {
          vm.loading = false
        }
      )
      vm.collectexportcustomersanalytic()
    },
    onExportCustomer(type) {
      this.exportType = type
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)
      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        if (this.exportType === 'dataSummary') {
          this.exportDataSummary(0)
        } else if (this.exportType === 'info') {
          this.exportCustomer(0)
        }
      }
    },
    importCustomer: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to import customer?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid
            }
            vm.loading = true
            vm.offset = 0
            vm.hasNext = true
            vm.users = []
            api.insertUsersFromInbox(data, async function(error, response) {
              if (error) {
                vm.loading = false
                return
              }
              if (response.responsecode == 200) {
                if (response.success) {
                  api.insertUsersFromDone(data, function(error, response) {
                    vm.getLoadUsers(vm.limit, vm.offset).then(
                      function(users) {
                        vm.users = vm.users.concat(users)
                        vm.delayImport = true
                        var time = dayjs()
                          .add(1, 'hours')
                          .format('YYYY-MM-DD HH:mm:ss')
                        vm.$store.commit('SET_DELAY_IMPORT', {
                          pageid: vm.selectedBot.pageid,
                          time: time
                        })
                        vm.$swal.fire({
                          title: vm.$t('Import customer successful'),
                          type: 'success',
                          confirmButtonText: vm.$t('Confirm'),
                          cancelButtonText: vm.$t('cancel'),
                          reverseButtons: true
                        })
                        vm.loading = false
                      },
                      function(error) {
                        vm.loading = false
                      }
                    )
                  })
                } else {
                  if (response.message) {
                    await vm.$swal.fire({
                      title: response.message,
                      type: 'error',
                      confirmButtonText: vm.$t('Confirm')
                    })
                    console.log(`insertUsersFromInbox -> ${response.message}`)
                  } else {
                    console.log('insertUsersFromInbox -> error')
                  }
                }
              }
            })
          }
        })
    }
  },
  watch: {
    count: function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/analytics/Customers.js